import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router";
import { SubjectListItem } from "../components/SubjectListItem";
import { allSubjects } from "../subjects";

const Category = () => {
  const { name } = useParams();

  const [categorySubjects, setCategorySubjects] = useState([]);

  useEffect(() => {
    setCategorySubjects(allSubjects[name]);
  }, [name]);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton text="Categories" />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonList>
          {categorySubjects.map((subject, index) => {
            return (
              <SubjectListItem subject={subject} key={`subject_${index}`} />
            );
          })}
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default Category;

